// forked from https://github.com/chakra-ui/chakra-ui/blob/main/packages/hooks/use-merge-refs/src/index.ts
import { useMemo } from 'react';
const assignRef = (ref, value) => {
    if (ref == null) {
        return;
    }
    if (typeof ref === 'function') {
        ref(value);
        return;
    }
    try {
        ref.current = value;
    }
    catch (error) {
        throw new Error(`Cannot assign value '${value}' to ref '${ref}'`);
    }
};
const mergeRefs = (...refs) => {
    return (node) => {
        refs.forEach(ref => {
            assignRef(ref, node);
        });
    };
};
const useMergeRefs = (...refs) => {
    return useMemo(() => mergeRefs(...refs), refs);
};
export default useMergeRefs;
